/* lua.js generated code 0.3.0 */

require('clover/def/GameItemDef')

GameItemDefManager = table()
GameItemDefMapKey = table()
GameItemDefManager.getDef = function (id) {
    var self = this
    if (self.defs[id]) {
        return self.defs[id]
    }
    return null
}
GameItemDefManager.createDef = function (id) {
    id = tonumber(id)
    if (id <= GameItemDefMapKey.kBird || id === GameItemDefMapKey.kHVLineRandom || id === GameItemDefMapKey.kNuclear) {
        // WARN: maybe multi result
        return GameItemDef.create()
    } else if (id === GameItemDefMapKey.kEmpty) {
        return EmptyItemDef.create()
    } else if (id <= GameItemDefMapKey.kIceLevel_3) {
        return IceItemDef.create()
    } else if (id <= GameItemDefMapKey.kSnowLevel_5) {
        // return SnowItemDef:create()
    } else if (id === GameItemDefMapKey.kLock) {
        return LockItemDef.create()
    } else if (id === GameItemDefMapKey.kCoin) {
        return CoinItemDef.create()
    } else if (id === GameItemDefMapKey.kCrystal) {
        return CrystalItemDef.create()
    } else if (id <= GameItemDefMapKey.kAlienB) {
        return AlienItemDef.create()
    } else if (id <= GameItemDefMapKey.kJewel_3) {
        // return DigItemDef:create()
    } else if (id <= GameItemDefMapKey.kChain_5) {
        return EdgeItemDef.create()
    } else if (id === GameItemDefMapKey.kWater) {
        // return WaterItemDef:create()
    } else if (id <= GameItemDefMapKey.kSeaAnimal_3_2 || id >= GameItemDefMapKey.kSoda_1_2 && id <= GameItemDefMapKey.kSoda_2_1 || id >= GameItemDefMapKey.kSoda_1_2_symmetry && id <= GameItemDefMapKey.kSoda_2_1_symmetry) {
        // WARN: maybe multi result
        return SeaAnimalDef.create()
    } else if (id <= GameItemDefMapKey.kColorBlock_6) {
        return ColorBlockDef.create()
    } else if (id <= GameItemDefMapKey.kFish_3) {
        return FishDef.create()
    } else if (id >= GameItemDefMapKey.kCircle && id <= GameItemDefMapKey.kCircle6) {
        return CircleItemDef.create()
    } else if (id === GameItemDefMapKey.kRoost) {
        return RoostItemDef.create()
    } else if (id <= GameItemDefMapKey.kRandomArea_3_2 || id === GameItemDefMapKey.kRandomArea_0) {
        return SeaAnimalRandomAreaDef.create()
    } else if (id <= GameItemDefMapKey.kRandom_Surper_Bird) {
        return GameItemDef.create()
    } else if (id === GameItemDefMapKey.kHoneyBottle) {
        return HoneyBottleDef.create()
    } else if (id === GameItemDefMapKey.kHoney) {
        return HoneyItemDef.create()
    } else if (id === GameItemDefMapKey.kStone) {
        return StoneItemDef.create()
    } else if (id === GameItemDefMapKey.kMissile) {
        return MissileItemDef.create()
    } else if (id >= GameItemDefMapKey.kVar_Snow_1 && id <= GameItemDefMapKey.kVar_Snow_5) {
        return VarSnowItemDef.create()
    } else if (id === GameItemDefMapKey.kBoss_Ignore_Area) {
        return BossIgnoreAreaItemDef.create()
    } else if (id >= GameItemDefMapKey.kFurball_1 && id <= GameItemDefMapKey.kFurball_3) {
        return FurballItemDef.create()
    } else if (id === GameItemDefMapKey.kFurball_4) {
        return FurballItemDef.create()
    } else if (id >= GameItemDefMapKey.kWaterBomb_0 && id <= GameItemDefMapKey.kWaterBomb_6) {
        return WaterBombItemDef.create()
    } else if (id === GameItemDefMapKey.kDandelion) {
        return DandelionItemDef.create()
    } else if (id === GameItemDefMapKey.kDandelionSeed) {
        return DandelionSeedItemDef.create()
    } else if (id === GameItemDefMapKey.kSubmarine) {
        return SubmarineItemDef.create()
    } else if (id === GameItemDefMapKey.kGather) {
        return GatherItemDef.create()
    } else if (id >= GameItemDefMapKey.kReef_1 && id <= GameItemDefMapKey.kReef_3) {
        return ReefItemDef.create()
    } else if (id === GameItemDefMapKey.kBoat) {
        return BoatItemDef.create()
    } else if (id === GameItemDefMapKey.kDigWater) {
        return DigWaterItemDef.create()
    } else if (id >= GameItemDefMapKey.kSoil_1 && id <= GameItemDefMapKey.kSoil_3 || id === GameItemDefMapKey.kSoil_lock) {
        return SoilItemDef.create()
    } else if (id >= GameItemDefMapKey.kGum_0 && id <= GameItemDefMapKey.kGum_6) {
        return GameItemDef.create()
    } else if (id === GameItemDefMapKey.kVariousBox) {
        return VariousBoxItemDef.create()
    } else if (id === GameItemDefMapKey.kFishLock) {
        return FishLockItemDef.create()
    } else if (id === GameItemDefMapKey.kBoss_Prefer_Area) {
        return BossPreferAreaItemDef.create()
    } else if (id === GameItemDefMapKey.kBoss_None_Area) {
        return BossNoneAreaItemDef.create()
    } else if (id === GameItemDefMapKey.kFishClock) {
        return FishClockItemDef.create()
    } else if (id === GameItemDefMapKey.kStarfish || (id >= GameItemDefMapKey.kStarfish_1 && id <= GameItemDefMapKey.kStarfish_6)) {
        return StarfishItemDef.create()
    } else if (id === GameItemDefMapKey.kMoveTile) {
        return MoveTileDef.create()
    } else if (id === GameItemDefMapKey.kMissile_Hate_Area) {
        return MissileHateAreaItemDef.create()
    } else if (id === GameItemDefMapKey.kVenom) {
        return VenomItemDef.create()
    } else if (id === GameItemDefMapKey.kVenomTroublesome) {
        return VenomTroublesomeItemDef.create()
    } else if (id >= GameItemDefMapKey.kFlowerVine_1 && id <= GameItemDefMapKey.kFlowerVine_4) {
        return FlowerVineItemDef.create()
    } else if (id === GameItemDefMapKey.kJellyfish) {
        return JellyfishItemDef.create()
    } else if (id === GameItemDefMapKey.kLighthouse) {
        return LightHouseItemDef.create()
    } else if (id === GameItemDefMapKey.kLotus) {
        return LotusItemDef.create()
    } else if (id === GameItemDefMapKey.kMagicLight) {
        // WARN: maybe multi result
        return MagicItemDef.create()
    } else if (id === GameItemDefMapKey.kRabbit) {
        // WARN: maybe multi result
        return RabbitItemDef.create()
    } else if (id >= GameItemDefMapKey.kSurfingCat_0 && id <= GameItemDefMapKey.kSurfingCat_6) {
        // WARN: maybe multi result
        return SurfingCatItemDef.create()
    } else if (id >= GameItemDefMapKey.kPaw_0 && id <= GameItemDefMapKey.kPaw_6) {
        // WARN: maybe multi result
        return GameItemDef.create()
    } else if (id === GameItemDefMapKey.kPursueStart) {
        // WARN: maybe multi result
        return PursueStartItemDef.create()
    } else if (id === GameItemDefMapKey.kPursueEnd) {
        // WARN: maybe multi result
        return BaseItemDef.create()
    } else if (id === GameItemDefMapKey.kForbitRefresh) {
        // WARN: maybe multi result
        return ForbitRefreshDef.create()
    } else if (id >= GameItemDefMapKey.kColorCollector_0 && id <= GameItemDefMapKey.kColorCollector_6) {
        // WARN: maybe multi result
        return ColorCollectorItemDef.create()
    } else if (id >= GameItemDefMapKey.kSurpriseBox_1 && id <= GameItemDefMapKey.kSurpriseBox_2) {
        // WARN: maybe multi result
        return SurpriseBoxItemDef.create()
    } else if (id == GameItemDefMapKey.kSurpriseBonus) {
        // WARN: maybe multi result
        return SurpriseBonusItemDef.create()
    } else if (id == GameItemDefMapKey.kVarousIgnore) {
        // WARN: maybe multi result
        return VarousBoxIgnoreAreaDef.create()
    } else if (id >= GameItemDefMapKey.kBigBox_1 && id <= GameItemDefMapKey.kBigBox_4) {
        // WARN: maybe multi result
        return BigBoxItemDef.create()
    } else if (id >= GameItemDefMapKey.kCake_1 && id <= GameItemDefMapKey.kCake_8) {
        // WARN: maybe multi result
        return CakeItemDef.create()
    } else if (id >= GameItemDefMapKey.kJamBox_1 && id <= GameItemDefMapKey.kJamBox_6) {
        // WARN: maybe multi result
        return JamBoxItemDef.create()
    } else if (id >= GameItemDefMapKey.kJam_1 && id <= GameItemDefMapKey.kJam_2) {
        // WARN: maybe multi result
        return JamItemDef.create()
    } else if (id === GameItemDefMapKey.kOneLife) {
        // WARN: maybe multi result
        return OneLifeItemDef.create()
    } else if (id === GameItemDefMapKey.kNoNuclear) {
        // WARN: maybe multi result
        return NoNuclearItemDef.create()
    } else if (id === GameItemDefMapKey.kBlockMachine) {
        // WARN: maybe multi result
        return BaseItemDef.create()
    } else if (id >= GameItemDefMapKey.kBowknot_1 && id <= GameItemDefMapKey.kBowknot_5) {
        // WARN: maybe multi result
        return BowknotItemDef.create()
    } else if (id >= GameItemDefMapKey.kScoreAnimal_0 && id <= GameItemDefMapKey.kScoreAnimal_6) {
        // WARN: maybe multi result
        return ScoreAnimalDef.create()
    } else if (id >= GameItemDefMapKey.kShell_1 && id <= GameItemDefMapKey.kShell_3) {
        // WARN: maybe multi result
        return ShellDef.create()
    } else if (id >= GameItemDefMapKey.kSuperHoneyBottle_1 && id <= GameItemDefMapKey.kSuperHoneyBottle_6) {
        // WARN: maybe multi result
        return SuperHoneyBottle.create()
    } else if (id === GameItemDefMapKey.kRiceBag) {
        // WARN: maybe multi result
        return RiceBagDef.create()
    } else if (id === GameItemDefMapKey.kGold || id === GameItemDefMapKey.kSilver) {
        // WARN: maybe multi result
        return BaseItemDef.create()
    } else if (id >= GameItemDefMapKey.kGoldPackage_1 && id <= GameItemDefMapKey.kGoldPackage_3) {
        // WARN: maybe multi result
        return GoldPackageDef.create()
    } else if (id === GameItemDefMapKey.kCandyFloss) {
        // WARN: maybe multi result
        return CandyFlossDef.create()
    } else if (id >= GameItemDefMapKey.kRatel_1 && id <= GameItemDefMapKey.kRatel_4) {
        // WARN: maybe multi result
        return RatelDef.create()
    } else if (id === GameItemDefMapKey.kWaterBox) {
        // WARN: maybe multi result
        return BaseItemDef.create()
    } else if (id >= GameItemDefMapKey.kVulnerable_1_1 && id <= GameItemDefMapKey.kVulnerable_3_4) {
        // WARN: maybe multi result
        return VulnerableDef.create()
    } else if (id >= GameItemDefMapKey.kCapsuleToy_3 && id <= GameItemDefMapKey.kCapsuleToy_1) {
        // WARN: maybe multi result
        return CapsuleToyItemDef.create()
    } else if (id === GameItemDefMapKey.kDisFourTile) {
        // WARN: maybe multi result
        return DisFourTile.create()
    } else if (id === GameItemDefMapKey.kGrass) {
        // WARN: maybe multi result
        return GrassItemDef.create()
    } else if (id === GameItemDefMapKey.kCandyCane) {
        // WARN: maybe multi result
        return CandyCaneItemDef.create()
    } else if (id === GameItemDefMapKey.kDinnertable) {
        // WARN: maybe multi result
        return DinnertableItemDef.create()
    } else if (id >= GameItemDefMapKey.kIceBomb_0 && id <= GameItemDefMapKey.kIceBomb_6) {
        // WARN: maybe multi result
        return IceBombItemDef.create()
    } else if (id >= GameItemDefMapKey.kCakeShooter_0 && id <= GameItemDefMapKey.kCakeShooter_6) {
        // WARN: maybe multi result
        return CakeShooterItemDef.create()
    } else if (id >= GameItemDefMapKey.kShark_0 && id <= GameItemDefMapKey.kShark_6) {
        // WARN: maybe multi result
        return SharkItemDef.create()
    } else if (id === GameItemDefMapKey.kGummyWorm) {
        // WARN: maybe multi result
        return GummyWormItemDef.create()
    } else if (id >= GameItemDefMapKey.kNestDoll_1 && id <= GameItemDefMapKey.kNestDoll_4) {
        // WARN: maybe multi result
        return NestDollItemDef.create()
    } else if (id >= GameItemDefMapKey.kNestDoll_Priority_1 && id <= GameItemDefMapKey.kNestDoll_Priority_2) {
        // WARN: maybe multi result
        return NestDollPriorityDef.create()
    } else if (id === GameItemDefMapKey.kBlastCrystal) {
        // WARN: maybe multi result
        return BlastCrystalDef.create()
    } else if (id >= GameItemDefMapKey.kRocket_0 && id <= GameItemDefMapKey.kRocket_6) {
        // WARN: maybe multi result
        return RocketDef.create()
    } else if (id === GameItemDefMapKey.kPropBlock) {
        // return PropBlockDef:create()
    } else if (id >= GameItemDefMapKey.kColoredFrosting_0_1 && id <= GameItemDefMapKey.kColoredFrosting_6_2) {
        // WARN: maybe multi result
        return ColoredFrostingItemDef.create()
    } else if (id >= GameItemDefMapKey.kPropBlock_0 && id <= GameItemDefMapKey.kPropBlock_6) {
        // WARN: maybe multi result
        return PropBlockDef.create()
    } else if (id === GameItemDefMapKey.kCandyYoyo) {
        // WARN: maybe multi result
        return CandyYoyoDef.create()
    } else if (id >= GameItemDefMapKey.kJamJar_1_1 && id <= GameItemDefMapKey.kJamJar_6_3) {
        // WARN: maybe multi result
        return JamJarDef.create()
    } else if (id === GameItemDefMapKey.kMint) {
        // WARN: maybe multi result
        return MintBlockDef.create()
    } else if (id === GameItemDefMapKey.kSeaAnemone) {
        // WARN: maybe multi result
        return SeaAnemoneDef.create()
    } else if (id === GameItemDefMapKey.kMushroom) {
        // WARN: maybe multi result
        return MushroomDef.create()
    } else if (id === GameItemDefMapKey.kFishnet) {
        // WARN: maybe multi result
        return FishnetDef.create()
    } else if (id === GameItemDefMapKey.kUFO) {
        // WARN: maybe multi result
        return UFODef.create()
    } else if (id >= GameItemDefMapKey.kFlashBird_0 && id <= GameItemDefMapKey.kFlashBird_6) {
        // WARN: maybe multi result
        return FlashBirdDef.create()
    } else if (id >= GameItemDefMapKey.kCheeseRat_1_0 && id <= GameItemDefMapKey.kCheeseRat_3_1) {
        // WARN: maybe multi result
        return CheeseRatDef.create()
    } else if (id >= GameItemDefMapKey.kPastry3 && id <= GameItemDefMapKey.kPastry6) {
        // WARN: maybe multi result
        return PastryDef.create()
    } else if (id >= GameItemDefMapKey.kCroissant1 && id <= GameItemDefMapKey.kCroissant3) {
        // WARN: maybe multi result
        return CroissantDef.create()
    } else if (id >= GameItemDefMapKey.kMiniOctopus_1 && id <= GameItemDefMapKey.kMiniOctopus_4) {
        // WARN: maybe multi result
        return MiniOctopusDef.create()
    } else if (id >= GameItemDefMapKey.kFoamBomb_1 && id <= GameItemDefMapKey.kFoamBomb_5) {
        // WARN: maybe multi result
        return FoamBombDef.create()
    } else if (id >= GameItemDefMapKey.kPopCan1 && id <= GameItemDefMapKey.kPopCan3) {
        // WARN: maybe multi result
        return PopCanDef.create()
    } else if (id >= GameItemDefMapKey.kFilbert_1 && id <= GameItemDefMapKey.kFilbert_3) {
        // WARN: maybe multi result
        return FilbertDef.create()
    } else if (id >= GameItemDefMapKey.kFireWork_0 && id <= GameItemDefMapKey.kFireWork_6) {
        // WARN: maybe multi result
        return FireWorkDef.create()
    } else if (id >= GameItemDefMapKey.kFireCracker_1 && id <= GameItemDefMapKey.kFireCracker_3) {
        // WARN: maybe multi result
        return FireCrackerDef.create()
    } else if (id === GameItemDefMapKey.kIcecreamCollector) {
        // WARN: maybe multi result
        return IcecreamCollectorDef.create()
    } else if (id === GameItemDefMapKey.kIcecream) {
        // WARN: maybe multi result
        return IcecreamDef.create()
    } else if (id === GameItemDefMapKey.kLamp || id === GameItemDefMapKey.kLampHead) {
        // WARN: maybe multi result
        return LampItemDef.create()
    } else if (id >= GameItemDefMapKey.kLaser0 && id <= GameItemDefMapKey.kLaser3) {
        // WARN: maybe multi result
        return LaserItemDef.create()
    } else if (id >= GameItemDefMapKey.kTorpedoRandom && id <= GameItemDefMapKey.kTorpedoYellow) {
        // WARN: maybe multi result
        return TorpedoItemDef.create()
    } else if (id === GameItemDefMapKey.kQualifyHat) {
        // WARN: maybe multi result
        return QualifyHatItemDef.create()
    } else if (id >= GameItemDefMapKey.kEgg1 && id <= GameItemDefMapKey.kEgg3) {
        // WARN: maybe multi result
        return EggItemDef.create()
    } else if (id >= GameItemDefMapKey.kDye1 && id <= GameItemDefMapKey.kDye6) {
        // WARN: maybe multi result
        return DyeItemDef.create()
    } else if (id >= GameItemDefMapKey.kMagicbottle1 && id <= GameItemDefMapKey.kMagicbottle2) {
        // WARN: maybe multi result
        return MagicbottleItemDef.create()
    } else if (id >= GameItemDefMapKey.kBombCandyA && id <= GameItemDefMapKey.kBombCandyYellow) {
        // WARN: maybe multi result
        return BombCandyItemDef.create()
    } else if (id >= GameItemDefMapKey.kBiscuit1 && id <= GameItemDefMapKey.kBiscuit4) {
        // WARN: maybe multi result
        return BiscuitItemDef.create()
    } else if (id === GameItemDefMapKey.kPopcorn) {
        // WARN: maybe multi result
        return PopcornItemDef.create()
    } else if (id === GameItemDefMapKey.kNest) {
        // WARN: maybe multi result
        return NestDef.create()
    } else if (id === GameItemDefMapKey.kHunter) {
        // WARN: maybe multi result
        return HunterItemDef.create()
    } else if (id === GameItemDefMapKey.kSafe) {
        // WARN: maybe multi result
        return SafeItemDef.create()
    } else if (id === GameItemDefMapKey.kIcePopBox) {
        // WARN: maybe multi result
        return IcePopBoxItemDef.create()
    } else if (id === GameItemDefMapKey.kActGiftBox) {
        // WARN: maybe multi result
        return ActGiftBoxItemDef.create()
    } else if (id >= GameItemDefMapKey.kDiamond1 && id <= GameItemDefMapKey.kDiamond3) {
        // WARN: maybe multi result
        return DiamondItemDef.create()
    } else if (id >= GameItemDefMapKey.kDiamondSolid1 && id <= GameItemDefMapKey.kDiamondSolid3) {
        // WARN: maybe multi result
        return DiamondSolidItemDef.create()
    } else if (id === GameItemDefMapKey.kTurnTileA) {
        // WARN: maybe multi result
        return TurnTileAItemDef.create()
    } else if (id === GameItemDefMapKey.kTurnTileB) {
        // WARN: maybe multi result
        return TurnTileBItemDef.create()
    } else if (id >= GameItemDefMapKey.kTurnTileControlA && id <= GameItemDefMapKey.kTurnTileControlA9) {
        // WARN: maybe multi result
        return TurnTileControlAItemDef.create()
    } else if (id >= GameItemDefMapKey.kTurnTileControlB && id <= GameItemDefMapKey.kTurnTileControlB9) {
        // WARN: maybe multi result
        return TurnTileControlBItemDef.create()
    } else if (id >= GameItemDefMapKey.kCannedFishA && id <= GameItemDefMapKey.kCannedFishBoth) {
        // WARN: maybe multi result
        return CannedFishItemDef.create()
    } else if (id >= GameItemDefMapKey.kCircusA && id <= GameItemDefMapKey.kCircusB) {
        // WARN: maybe multi result
        return CircusItemDef.create()
    } else if (id >= GameItemDefMapKey.kCircus_Ball_1 && id <= GameItemDefMapKey.kCircus_Ball_2) {
        // WARN: maybe multi result
        return CircusBallItemDef.create()
    } else if (id >= GameItemDefMapKey.kWoodBox_1 && id <= GameItemDefMapKey.kWoodBox_5) {
        // WARN: maybe multi result
        return WoodBoxItemDef.create()
    } else if (id >= GameItemDefMapKey.kMangosteen_1 && id <= GameItemDefMapKey.kMangosteen_0) {
        // WARN: maybe multi result
        return MangosteenItemDef.create()
    } else if (id >= GameItemDefMapKey.kSupportStickV && id <= GameItemDefMapKey.kSupportStickH) {
        // WARN: maybe multi result
        return SupportStickItemDef.create()
    }
    return null
}
GameTargetUID = table()
GameItemDefManager.encodeTarget = function () {
    let self = this
    // 以下初始化顺序不得变更，只能在最后追加,且从0开始编号
    GameTargetUID[GameItemDefMapKey.kBlue] = 0
    GameTargetUID[GameItemDefMapKey.kGreen] = 1
    GameTargetUID[GameItemDefMapKey.kBrown] = 2
    GameTargetUID[GameItemDefMapKey.kPurple] = 3
    GameTargetUID[GameItemDefMapKey.kRed] = 4
    GameTargetUID[GameItemDefMapKey.kYellow] = 5
    GameTargetUID[GameItemDefMapKey.kCoin] = 6
    GameTargetUID[GameItemDefMapKey.kAlienB] = 7
    GameTargetUID[GameItemDefMapKey.kSeaAnimal_1_1] = 8
    GameTargetUID[GameItemDefMapKey.kSeaAnimal_1_2] = 9
    GameTargetUID[GameItemDefMapKey.kSeaAnimal_2_2] = 10
    GameTargetUID[GameItemDefMapKey.kSeaAnimal_3_2] = 11
    GameTargetUID[GameItemDefMapKey.kColorBlock_1] = 12
    GameTargetUID[GameItemDefMapKey.kColorBlock_2] = 13
    GameTargetUID[GameItemDefMapKey.kColorBlock_3] = 14
    GameTargetUID[GameItemDefMapKey.kColorBlock_4] = 15
    GameTargetUID[GameItemDefMapKey.kColorBlock_5] = 16
    GameTargetUID[GameItemDefMapKey.kColorBlock_6] = 17
    GameTargetUID[GameItemDefMapKey.kFish_1] = 18
    GameTargetUID[GameItemDefMapKey.kHoney] = 19
    GameTargetUID[GameItemDefMapKey.kVar_Snow_1] = 20
    GameTargetUID[GameItemDefMapKey.kDandelionSeed] = 21
    GameTargetUID[GameItemDefMapKey.kBoat] = 22
    GameTargetUID[GameItemDefMapKey.kGum_0] = 23
    GameTargetUID[GameItemDefMapKey.kGum_1] = 24
    GameTargetUID[GameItemDefMapKey.kGum_2] = 25
    GameTargetUID[GameItemDefMapKey.kGum_3] = 26
    GameTargetUID[GameItemDefMapKey.kGum_4] = 27
    GameTargetUID[GameItemDefMapKey.kGum_5] = 28
    GameTargetUID[GameItemDefMapKey.kGum_6] = 29
    GameTargetUID[GameItemDefMapKey.kStarfish] = 30
    GameTargetUID[GameItemDefMapKey.kLighthouse] = 31
    GameTargetUID[GameItemDefMapKey.kPaw_0] = 32
    GameTargetUID[GameItemDefMapKey.kSurpriseBonus] = 33
    GameTargetUID[GameItemDefMapKey.kRiceBag] = 34
    GameTargetUID[GameItemDefMapKey.kCapsuleToy_3] = 35
    GameTargetUID[GameItemDefMapKey.kCapsuleToy_2] = 36
    GameTargetUID[GameItemDefMapKey.kCapsuleToy_1] = 37
    GameTargetUID[GameItemDefMapKey.kCheeseRat_1_1] = 38
    GameTargetUID[GameItemDefMapKey.kPastry3] = 39
    GameTargetUID[GameItemDefMapKey.kCroissant1] = 40
    GameTargetUID[GameItemDefMapKey.kFilbert_1] = 41
    GameTargetUID[GameItemDefMapKey.kFireCracker_1] = 42
    GameTargetUID[GameItemDefMapKey.kEgg1] = 43
    GameTargetUID[GameItemDefMapKey.kBombCandyBlue] = 44
    GameTargetUID[GameItemDefMapKey.kBombCandyGreen] = 45
    GameTargetUID[GameItemDefMapKey.kBombCandyBrown] = 46
    GameTargetUID[GameItemDefMapKey.kBombCandyPurple] = 47
    GameTargetUID[GameItemDefMapKey.kBombCandyRed] = 48
    GameTargetUID[GameItemDefMapKey.kBombCandyYellow] = 49
    GameTargetUID[GameItemDefMapKey.kBiscuit1] = 50
    GameTargetUID[GameItemDefMapKey.kCannedFishA] = 51
    GameTargetUID[GameItemDefMapKey.kCannedFishB] = 52
    GameTargetUID[GameItemDefMapKey.kCannedFishBoth] = 53
    GameTargetUID[GameItemDefMapKey.kShark_1] = 54
    GameTargetUID[GameItemDefMapKey.kShark_2] = 55
    GameTargetUID[GameItemDefMapKey.kShark_3] = 56
    GameTargetUID[GameItemDefMapKey.kShark_4] = 57
    GameTargetUID[GameItemDefMapKey.kShark_5] = 58
    GameTargetUID[GameItemDefMapKey.kShark_6] = 59
    GameTargetUID[GameItemDefMapKey.kJam_1] = 60
    GameTargetUID[GameItemDefMapKey.kIcePopBox] = 61
    GameTargetUID[GameItemDefMapKey.kWoodBox_1] = 62
    GameTargetUID[GameItemDefMapKey.kMangosteen_1] = 63
}
GameItemDefManager.init = function () {
    var self = this
    self.defs = table()
    var path = "meta/item_def.json"
    //he_log_info(path)
    //path = cc.FileUtils.getInstance().fullPathForFilename(path)

    he_log_info("full: " + tostring(path))
    
    var cfg = cc.loader.getRes(path)
    //var cfg = cc.FileUtils.getInstance().getStringFromFile(path)
    //cfg = cfg.gsub("//[^\n]*\n", "")
    if (cfg) {
        //cfg = table.deserialize(cfg)
        for (var k in cfg) {
            var v = cfg[k]
            GameItemDefMapKey[v.mapKey] = tonumber(k)
        }
        //生成def列表,通过id可索引
        for (var k in cfg) {
            var v = cfg[k]
            var def = self.createDef(k)
            if (def) {
                def.initWithData(k, v)
                self.defs[k] = def
            }
        }
    }
}
GameItemDefManager.getItemDefIdByItemType = function (itemType) {
    var self = this
    var def = self.getDef(itemType)
    if (def) {
        return def.id
    }
    return null
}
GameItemDefManager.getItemDefSizeById = function (id) {
    var self = this
    var size = { width: 1, height: 1 }
    var def = self.getDef(id)
    if (def) {
        size.width = def.width || 1
        size.height = def.height || 1
    }
    return size
}
//仅作掉落规则使用
GameItemDefManager.isSameDef = function (id1, id2) {
    id1 = tonumber(id1)
    id2 = tonumber(id2)
    function getID(id) {
        if (id <= GameItemDefMapKey.kBird) { } else if (id === GameItemDefMapKey.kEmpty) { } else if (id <= GameItemDefMapKey.kIceLevel_3) {
            return GameItemDefMapKey.kIceLevel_3
        } else if (id <= GameItemDefMapKey.kSnowLevel_5) {
            return GameItemDefMapKey.kSnowLevel_5
        } else if (id === GameItemDefMapKey.kLock) { } else if (id === GameItemDefMapKey.kCoin) { } else if (id === GameItemDefMapKey.kCrystal) { } else if (id <= GameItemDefMapKey.kAlienB) {
            return GameItemDefMapKey.kAlienB
        } else if (id <= GameItemDefMapKey.kJewel_3) {
            return GameItemDefMapKey.kJewel_3
        } else if (id <= GameItemDefMapKey.kChain_5) {
            return GameItemDefMapKey.kChain_5
        } else if (id === GameItemDefMapKey.kWater) { } else if (id <= GameItemDefMapKey.kSeaAnimal_3_2 || id >= GameItemDefMapKey.kSoda_1_2 && id <= GameItemDefMapKey.kSoda_2_1 || id >= GameItemDefMapKey.kSoda_1_2_symmetry && id <= GameItemDefMapKey.kSoda_2_1_symmetry) {
            return GameItemDefMapKey.kSeaAnimal_3_2
        } else if (id <= GameItemDefMapKey.kColorBlock_6) {
            return GameItemDefMapKey.kColorBlock_6
        } else if (id <= GameItemDefMapKey.kFish_3) {
            return GameItemDefMapKey.kFish_3
        } else if (id >= GameItemDefMapKey.kCircle && id <= GameItemDefMapKey.kCircle6) {
            return GameItemDefMapKey.kCircle6
        } else if (id === GameItemDefMapKey.kRoost) { } else if (id <= GameItemDefMapKey.kRandomArea_3_2) {
            return GameItemDefMapKey.kRandomArea_3_2
        } else if (id <= GameItemDefMapKey.kRandom_Surper_Bird) { } else if (id === GameItemDefMapKey.kHoneyBottle || id === GameItemDefMapKey.kHoney) {
            return GameItemDefMapKey.kHoney
        } else if (id === GameItemDefMapKey.kStone) { } else if (id === GameItemDefMapKey.kMissile) { } else if (id >= GameItemDefMapKey.kVar_Snow_1 && id <= GameItemDefMapKey.kVar_Snow_5) {
            return GameItemDefMapKey.kVar_Snow_5
        } else if (id >= GameItemDefMapKey.kFurball_1 && id <= GameItemDefMapKey.kFurball_3) {
            return GameItemDefMapKey.kFurball_1
        } else if (id === GameItemDefMapKey.kFurball_4) {
            return GameItemDefMapKey.kFurball_1
        } else if (id >= GameItemDefMapKey.kDandelion && id <= GameItemDefMapKey.kDandelionSeed) {
            return GameItemDefMapKey.kDandelionSeed
        } else if (id === GameItemDefMapKey.kSubmarine) { } else if (id === GameItemDefMapKey.kGather) { } else if (id >= GameItemDefMapKey.kReef_1 && id <= GameItemDefMapKey.kReef_3) {
            return GameItemDefMapKey.kReef_3
        } else if (id == GameItemDefMapKey.kBoat) { } else if (id == GameItemDefMapKey.kDigWater) { } else if (id >= GameItemDefMapKey.kSoil_1 && id <= GameItemDefMapKey.kSoil_3 || id == GameItemDefMapKey.kSoil_lock) {
            return GameItemDefMapKey.kSoil_3
        } else if (id === GameItemDefMapKey.kVariousBox) {
            return GameItemDefMapKey.kVariousBox
        } else if (id === GameItemDefMapKey.kFishClock) {
            return GameItemDefMapKey.kFishClock
        } else if (id === GameItemDefMapKey.kMissile_Hate_Area) {
            return GameItemDefMapKey.kMissile_Hate_Area
        } else if (id >= GameItemDefMapKey.kSurfingCat_0 && id <= GameItemDefMapKey.kSurfingCat_6) {
            return GameItemDefMapKey.kSurfingCat_0
        } else if (id >= GameItemDefMapKey.kColorCollector_0 && id <= GameItemDefMapKey.kColorCollector_6) {
            return GameItemDefMapKey.kColorCollector_0
        } else if (id >= GameItemDefMapKey.kSurpriseBox_1 && id <= GameItemDefMapKey.kSurpriseBox_2) {
            return GameItemDefMapKey.kSurpriseBox_1
        } else if (id == GameItemDefMapKey.kSurpriseBonus) {
            return GameItemDefMapKey.kSurpriseBonus
        } else if (id >= GameItemDefMapKey.kBigBox_1 && id <= GameItemDefMapKey.kBigBox_4) {
            return GameItemDefMapKey.kBigBox_1
        } else if (id >= GameItemDefMapKey.kCake_1 && id <= GameItemDefMapKey.kCake_2) {
            return GameItemDefMapKey.kCake_1
        } else if (id === GameItemDefMapKey.kOneLife) {
            return GameItemDefMapKey.kOneLife
        } else if (id >= GameItemDefMapKey.kBowknot_1 && id <= GameItemDefMapKey.kBowknot_5) {
            return GameItemDefMapKey.kBowknot_1
        } else if (id === GameItemDefMapKey.kRiceBag) {
            return GameItemDefMapKey.kRiceBag
        } else if (id >= GameItemDefMapKey.kRatel_1 && id <= GameItemDefMapKey.kRatel_4) {
            return GameItemDefMapKey.kRatel_1
        } else if (id >= GameItemDefMapKey.kCapsuleToy_3 && id <= GameItemDefMapKey.kCapsuleToy_1) {
            return GameItemDefMapKey.kCapsuleToy_3
        } else if (id === GameItemDefMapKey.kGrass) {
            return GameItemDefMapKey.kGrass
        } else if (id === GameItemDefMapKey.kDinnertable) {
            return GameItemDefMapKey.kDinnertable
        } else if (id === GameItemDefMapKey.kIceBomb_0 && id === GameItemDefMapKey.kIceBomb_6) {
            return GameItemDefMapKey.kIceBomb_0
        } else if (id === GameItemDefMapKey.kCakeShooter_0 && id === GameItemDefMapKey.kCakeShooter_6) {
            return GameItemDefMapKey.kCakeShooter_0
        } else if (id >= GameItemDefMapKey.kNestDoll_1 && id <= GameItemDefMapKey.kNestDoll_4) {
            return GameItemDefMapKey.kNestDoll_1
        } else if (id >= GameItemDefMapKey.kRocket_0 && id <= GameItemDefMapKey.kRocket_6) {
            return GameItemDefMapKey.kRocket_0
        } else if (id >= GameItemDefMapKey.kColoredFrosting_0_1 && id <= GameItemDefMapKey.kColoredFrosting_6_2) {
            return GameItemDefMapKey.kColoredFrosting_0_1
        } else if (id === GameItemDefMapKey.kCandyYoyo) {
            return GameItemDefMapKey.kCandyYoyo
        } else if (id >= GameItemDefMapKey.kPopCan1 && id <= GameItemDefMapKey.kPopCan3) {
            return GameItemDefMapKey.kPopCan1
        } else if (id >= GameItemDefMapKey.kFireWork_0 && id <= GameItemDefMapKey.kFireWork_6) {
            return GameItemDefMapKey.kFireWork_0
        } else if (id === GameItemDefMapKey.kLamp || id === GameItemDefMapKey.kLampHead) {
            return GameItemDefMapKey.kLamp
        } else if (id >= GameItemDefMapKey.kLaser0 && id <= GameItemDefMapKey.kLaser3) {
            return GameItemDefMapKey.kLaser0
        } else if (id >= GameItemDefMapKey.kEgg1 && id <= GameItemDefMapKey.kEgg3) {
            return GameItemDefMapKey.kEgg1
        } else if (id >= GameItemDefMapKey.kDye1 && id <= GameItemDefMapKey.kDye6) {
            return GameItemDefMapKey.kDye1
        } else if (id >= GameItemDefMapKey.kMagicbottle1 && id <= GameItemDefMapKey.kMagicbottle2) {
            return GameItemDefMapKey.kMagicbottle1
        }  else if (id === GameItemDefMapKey.kTurnTileA) {
            return GameItemDefMapKey.kTurnTileA
        } else if (id === GameItemDefMapKey.kTurnTileB) {
            return GameItemDefMapKey.kTurnTileB
        } else if (id >= GameItemDefMapKey.kTurnTileControlA && id <= GameItemDefMapKey.kTurnTileControlA9) {
            return GameItemDefMapKey.kTurnTileControlA
        } else if (id >= GameItemDefMapKey.kTurnTileControlB && id <= GameItemDefMapKey.kTurnTileControlB9) {
            return GameItemDefMapKey.kTurnTileControlB
        } else if (id >= GameItemDefMapKey.kCircus_Ball_1 && id <= GameItemDefMapKey.kCircus_Ball_2) {
            return GameItemDefMapKey.kCircus_Ball_1
        } else if (id >= GameItemDefMapKey.kSupportStickV && id <= GameItemDefMapKey.kSupportStickH) {
            return GameItemDefMapKey.kSupportStickV
        }
    }
    function check(id1, id2) {
        if (id2 === GameItemDefMapKey.kRandom && id1 >= GameItemDefMapKey.kRandom && id1 <= GameItemDefMapKey.kYellow) {
            return true
        }
        if (id2 === GameItemDefMapKey.kHLineRandom && id1 >= GameItemDefMapKey.kHLineRandom && id1 <= GameItemDefMapKey.kHLineYellow) {
            return true
        }
        if (id2 === GameItemDefMapKey.kVLineRandom && id1 >= GameItemDefMapKey.kVLineRandom && id1 <= GameItemDefMapKey.kVlineYellow) {
            return true
        }
        if (id2 === GameItemDefMapKey.kCrossRandom && id1 >= GameItemDefMapKey.kCrossRandom && id1 <= GameItemDefMapKey.kCrossYellow) {
            return true
        }
        if (id2 === GameItemDefMapKey.kWrapRandom && id1 >= GameItemDefMapKey.kWrapRandom && id1 <= GameItemDefMapKey.kWrapYellow) {
            return true
        }
        if (id2 === GameItemDefMapKey.kRandom_Surper_Bird && id1 >= GameItemDefMapKey.kBlue_Surper_Bird && id1 <= GameItemDefMapKey.kRandom_Surper_Bird) {
            return true
        }
    }
    var id11 = getID(id1)
    var id22 = getID(id2)
    return id11 && id22 && id11 === id22 || check(id1, id2)
}
GameItemDefManager.init()
GameItemDefManager.encodeTarget()
